import { cls } from '@react/utils/classname'
import { ReactElement } from 'react'

type SearchLoadMoreButtonProps = {
  hidden?: boolean
  label?: string
  onClick?: () => void
}

export function SearchLoadMoreButton({ hidden = true, label = '', onClick }: SearchLoadMoreButtonProps): ReactElement {
  return (
    <div
      className={cls({ 'saas-search-result-tab__button-more': true, 'cmp-button--secondary-positive': true })}
      data-testid="search-load-more-button-component"
    >
      <button
        className={cls({ 'cmp-button saas-search-result-tab__button': true, 'saas-search-results--is-hidden': hidden })}
        disabled={hidden}
        onClick={onClick}
        type="button"
        data-testid="search-load-more-button"
      >
        <span className="cmp-button__text saas-search-result-tab__button-more-text" data-testid="search-load-more-button-label">
          {label}
        </span>
        <span className="cmp-button__icon cmp-button__icon--arrow_down"></span>
      </button>
    </div>
  )
}
